"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactstrap = require("reactstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var DefaultBodyStyle = {
  backgroundColor: "#ffffff",
  color: "#000000",
  borderColor: "rgba(0, 0, 0, 0.125)"
};

var Body = _styledComponents["default"].div.withConfig({
  displayName: "AccordionBody__Body",
  componentId: "mo1gca-0"
})(["background:", ";color:", ";padding:", ";&&&{border-left:", ";border-bottom:", ";border-right:", ";}"], function (props) {
  return props.styles.backgroundColor;
}, function (props) {
  return props.styles.color;
}, function (props) {
  return props.padding ? "10px" : "0px";
}, function (props) {
  return "1px solid " + props.styles.borderColor;
}, function (props) {
  return "1px solid " + props.styles.borderColor;
}, function (props) {
  return "1px solid " + props.styles.borderColor;
});

var AccordionBody = function AccordionBody(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? true : _ref$padding,
      styles = _ref.styles,
      rest = _objectWithoutProperties(_ref, ["children", "isOpen", "padding", "styles"]);

  var CompStyles = _objectSpread({}, DefaultBodyStyle, {}, styles);

  return _react["default"].createElement(_reactstrap.Collapse, {
    isOpen: isOpen
  }, _react["default"].createElement(Body, _extends({
    padding: padding,
    styles: CompStyles
  }, rest), children));
};

AccordionBody.propTypes = {
  /** If the accordion body is open - this is maintained by the accordion wrapper*/
  isOpen: _propTypes["default"].bool,

  /** Any Children to display in body of accordion */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),

  /** Padding on the body */
  padding: _propTypes["default"].bool,

  /** Custom styles object of the  accordion body */
  styles: _propTypes["default"].shape({
    backgroundColor: _propTypes["default"].string,
    color: _propTypes["default"].string,
    borderColor: _propTypes["default"].string
  })
};
AccordionBody.defaultProps = {
  styles: DefaultBodyStyle,
  padding: true,
  isOpen: false,
  children: null
};
AccordionBody.displayName = "Body";
var _default = AccordionBody;
exports["default"] = _default;